__turbopack_context__.v({
  "className": "-_Fr9q_className",
  "variable": "-_Fr9q_variable",
});
